import { useState } from "react";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import CourseRegistrationModal from "../components/courses/CourseRegistrationModal";
import courses from "../data/courses/coursesData";

export default function CoursesPage() {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedCourse, setSelectedCourse] = useState("");

  const openModal = (courseTitle) => {
    setSelectedCourse(courseTitle);
    setIsOpen(true);
  };

  const closeModal = () => {
    setIsOpen(false);
    setSelectedCourse("");
  };

  return (
    <main className="bg-gray-50 min-h-screen">
      <div className="max-w-7xl mx-auto px-6 py-12 space-y-20">
        {courses.map((course, idx) => (
          <section
            key={idx}
            className="grid md:grid-cols-2 items-center gap-10 bg-white rounded-xl shadow-lg p-6"
          >
            {/* Image */}
            <div
              className={`relative w-full ${
                idx % 2 === 1 ? "md:order-2" : ""
              }`}
            >
              <img
                src={course.img}
                alt={course.title}
                className="rounded-xl w-full object-cover shadow-md"
              />

              <span
                className={`absolute top-4 ${
                  course.type === "Online" ? "left-4" : "right-4"
                } ${course.badgeColor} text-white text-xs md:text-sm font-semibold px-3 py-1 rounded-full`}
              >
                {course.type}
              </span>
            </div>

            {/* Content */}
            <div className={idx % 2 === 1 ? "md:order-1" : ""}>
              <h2
                className={`text-2xl md:text-3xl font-bold ${course.textColor}`}
              >
                {course.title}
              </h2>

              <p className="text-gray-600 mt-3 leading-relaxed">
                {course.description}
              </p>

              <ul className="mt-5 space-y-2 text-gray-700 list-disc pl-5">
                {course.features.map((feature, i) => (
                  <li key={i}>{feature}</li>
                ))}
              </ul>

              <button
                type="button"
                onClick={() => openModal(course.title)}
                className={`mt-6 ${course.btnColor} text-white px-6 py-3 rounded-lg shadow-md transition font-semibold`}
              >
                Enquire Now
              </button>
            </div>
          </section>
        ))}
      </div>

      {/* Registration Modal */}
      {isOpen && (
        <CourseRegistrationModal
          selectedCourse={selectedCourse}
          closeModal={closeModal}
        />
      )}

      {/* Toast Notifications */}
      <ToastContainer />
    </main>
  );
}
